export class CalcolaDimensioniRequestDTO {
  idDocuments: string[];
  sizeLimit: number;
}
